module.exports = __webpack_public_path__ + "img/4_x12.b27b325d.png";